import * as React from 'react';
import { WrappedFC } from '../shared/types';

interface Props {
  onChange: (event: any) => void;
}

const DEFAULT_COMPONENT: keyof JSX.IntrinsicElements = 'input';

/**
 * input type=textのコンポーネント
 */
export const Input: WrappedFC<typeof DEFAULT_COMPONENT, Props> = ({
  type,
  className,
  element: Element = DEFAULT_COMPONENT,
  ...props
}) => {
  const _type = type || 'text';
  const _clsName = className || _type;
  return (
    <Element type={_type} {...props} className={_clsName}>
      {props.children}
    </Element>
  );
};
Input.displayName = 'Input';
